import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiTruck, FiAward, FiRefreshCw } from 'react-icons/fi';
import SEO from '../components/SEO';
import ProductCard from '../components/ProductCard';
import TrendingCard from '../components/TrendingCard';
import CategoryRow from '../components/CategoryRow';
import apiClient from '../utils/apiClient';
import '../styles/Home.css';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch sections and featured products in parallel
        const [sectionsResponse, featuredResponse] = await Promise.all([
          apiClient.get('/trending/sections'),
          apiClient.get('/trending/featured')
        ]);

        setSections(sectionsResponse.data.sections || []);
        setFeaturedProducts(featuredResponse.data.products || []);
      } catch (error) {
        console.error('Error fetching home data:', error);
        // Fallback sections
        setSections([
          { id: 'stationary', name: 'Stationary' },
          { id: 'textiles', name: 'Textiles & Fabrics' },
          { id: 'pottery', name: 'Pottery & Ceramics' },
          { id: 'handicrafts', name: 'Handicrafts' },
          { id: 'electronics', name: 'Electronics' },
          { id: 'home-decor', name: 'Home Decor' }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Filter out 'featured' from sections as it's displayed separately
  const categoryRows = sections.filter(section => section.id !== 'featured');

  return (
    <div className="home">
      <SEO
        title="Authentic Handmade Crafts & Home Décor"
        description="Discover authentic handmade crafts, textiles, pottery, and home décor created by skilled artisans. Shop unique handcrafted products with worldwide shipping."
        canonical="https://kalingastore.shop/"
      />
      {/* Hero Banner */}
      <section className="hero">
        <div className="hero-content">
          <h1>Discover Authentic Indian Crafts</h1>
          <p>Shop handmade and manufactured products directly from Producers</p>
          <Link to="/products" className="hero-btn">
            Shop Now <FiArrowRight />
          </Link>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits">
        <div className="benefit-card">
          <FiTruck size={40} />
          <h3>Free Shipping</h3>
          <p>On orders above ₹499</p>
        </div>
        <div className="benefit-card">
          <FiAward size={40} />
          <h3>Authentic Products</h3>
          <p>Directly from artisans</p>
        </div>
        <div className="benefit-card">
          <FiRefreshCw size={40} />
          <h3>Easy Returns</h3>
          <p>7-day return policy</p>
        </div>
      </section>



      {/* Featured Products Section */}
      <section className="featured-section">
        <div className="section-header">
          <h2>Featured Products</h2>
          <Link to="/products" className="view-all-link">
            View All <FiArrowRight />
          </Link>
        </div>
        <div className="trending-grid">
          {featuredProducts.map((product) => (
            <TrendingCard key={product.id} product={product} />
          ))}
        </div>
      </section>

      {/* Dynamic Category Trending Sections */}
      {categoryRows.map(section => (
        <CategoryRow
          key={section.id}
          category={section.id}
          title={section.name}
        />
      ))}

      {/* Special Offer Banner */}
      <section className="offer-banner">
        <div className="offer-content">
          <h2>Special Offer This Month</h2>
          <p>Get up to 50% off on selected items</p>
          <Link to="/products" className="offer-btn">
            Shop Now
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
